import { createContext } from 'react';

export const OrderContext = createContext({
  order: [],
  setOrder: order => {},
});
